import * as React from 'react';
import { IconProps } from '../types';

const IcFullTurn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M11.367 23c-2.917 0-5.715-1.212-7.778-3.368C1.526 17.475.367 14.55.367 11.5s1.16-5.975 3.222-8.132C5.652 1.212 8.45 0 11.367 0v23ZM13.367 0c2.918 0 5.716 1.212 7.779 3.368 2.063 2.157 3.221 5.082 3.221 8.132s-1.159 5.975-3.221 8.132C19.083 21.788 16.285 23 13.367 23V0Z" />
    </g>
    <defs>
      <clipPath id="a">
        <rect
          width={24}
          height={24}
          x={24.367}
          y={24}
          fill="#fff"
          rx={12}
          transform="rotate(180 24.367 24)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IcFullTurn;
